import { Box, Button, Grid, Paper, Typography, /* useMediaQuery  */} from "@mui/material";
import { DragEvent, useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { FileInsTargetRequest } from "../../../redux/file/fileInsSlice";
import { useSelector } from "react-redux";
import { LoadState } from "../../../redux/common";
import { PRIZA_THEME } from "../../..";
import { fileUpload, filesUploadSlice, selectFilesUpload } from "../../../redux/file/filesUploadSlice";
import ReplayIcon from "@mui/icons-material/Replay";
import CancelIcon from "@mui/icons-material/Cancel";

export interface ElementUploadFilesProps {
    // name: string;
    back: () => void;
    target: FileInsTargetRequest;
}

export function ElementUploadFiles(props: ElementUploadFilesProps) {
    const [dragOver, setDragOver] = useState(false);
    // determines if the file is being loaded in the component
    // const [loading, setLoading] = useState(false);
    // determines if some file was loaded, and it can be uploaded
    // const [loaded, setLoaded] = useState(false);
    const [sending, setSending] = useState(false);
    const [rawfiles, setRawFiles] = useState<Record<string, File>>({});
    const dispatch = useAppDispatch();
    const filesUpload = useSelector(selectFilesUpload);

    const handleDrag = (event: DragEvent) => {
        event.stopPropagation();
        event.preventDefault();
        // const target = (event.target as HTMLDivElement);
        setDragOver(event.type === "dragover");
    };
  
    const handleDrop = (event: any) => {
        event.preventDefault();
        setDragOver(false);
        const files = event.dataTransfer.files;
        for(let i = 0; i < files.length; i++) {
            handleFileChange(files[i]);
        }
    };

    const handleFileChange = (obj: any) => {
        const file = obj as File;
        // setLoading(true);
        // setLoaded(false);
        const reader = new FileReader();
        reader.onloadend = () => {
            // setLoading(false);
            // setLoaded(true);
            if(reader && reader.result && typeof reader.result === "string") {
                rawfiles[file.name] = file;
                setRawFiles(rawfiles);
                dispatch( filesUploadSlice.actions.add({filename: file.name, preview: reader.result}) );
            }
        };
        reader.readAsDataURL(file);
    };

    const handleChange =  (event: any) => {
        console.log(`change ${event.target.id}`);
        const files = event.target.files;
        for(let i = 0; i < files.length; i++) {
            handleFileChange(files[i]);
        }
    };

    const files = [];
    let countUploading = 0;
    try {
        // const items = Object.values(filesUpload.files);
        for(const item in filesUpload.files) {
            const retry = (event: any) => {
                event.stopPropagation();
                dispatch( filesUploadSlice.actions.retry(item) );
            };
            const remove = (event: any) => {
                event.stopPropagation();
                dispatch( filesUploadSlice.actions.remove(item) );
            };

            const file = filesUpload.files[item];
            let status = undefined;
            let backgroundColor = undefined;
            let message = undefined;
            let action = undefined;
            switch(file.state.state) {
                case LoadState.Loading: 
                    status = "Carregando"; 
                    backgroundColor = "rgba(0, 0, 155, 0.5)"; 
                    message = "Processando filem";
                    countUploading++;
                    break;
                case LoadState.Loaded: 
                    status = "Carregado"; 
                    backgroundColor = "rgba(0, 155, 0, 0.5)"; 
                    message = "Filem carregada com sucesso";
                    break;
                case LoadState.Failed: 
                    status = "Erro"; 
                    backgroundColor = "rgba(155, 0, 0, 0.5)"; 
                    message = "Erro ao carregar filem";
                    action = <Button variant="contained" sx={{m: 1}} aria-label={"Retry"} onClick={(event) => retry(event)}>
                            <ReplayIcon />
                        </Button>;
                    break;
                default: 
                    status = "Aguardando"; 
                    backgroundColor = "rgba(0, 0, 0, 0.5)"; 
                    message = "Aguardando para o envio";
                    action = <Button variant="contained" sx={{m: 1}} aria-label={"remover"} onClick={(event) => remove(event)}>
                            <CancelIcon />
                        </Button>;
                    break;
            }
            files.push(
                {status, message, backgroundColor, action, file}
                // <FileListItem key={file.filename} sx={{ minHeight: 200, maxHeight: 200 }}>
                //     <img src={file.preview} alt={file.filename} />
                //     <FileListItemBar
                //         title={status}
                //         subtitle={message}
                //         sx={{ background: backgroundColor, color: "white"}}
                //         actionIcon={action}
                //     />
                // </FileListItem>
            );
        }
    } catch(e) {
        console.error(e);
    }

    if(sending && countUploading < 3) {
        for(const fileName in filesUpload.files) {
            const file = filesUpload.files[fileName];
            if(file.state.state == LoadState.NotStarted) {
                console.log(`ElementUploadFiles ${JSON.stringify(props)}`);

                dispatch(fileUpload({file: file, raw: rawfiles[fileName], target: props.target}));
                countUploading++;
                if(countUploading >= 3)
                    break;
            }
        }
    }

    if(countUploading == 0 && sending) {
        setSending(false);
    }

    // const isSm = useMediaQuery(PRIZA_THEME.breakpoints.up("sm"));
    // const isMd = useMediaQuery(PRIZA_THEME.breakpoints.up("md"));
    // const isLg = useMediaQuery(PRIZA_THEME.breakpoints.up("lg"));
    // const isXl = useMediaQuery(PRIZA_THEME.breakpoints.up("xl"));

    // const columnCount =
    //     isXl ? 4 :
    //     isMd ? 3 :
    //     isLg ? 2 :
    //     isSm ? 1 : 1;

    const buttons = <>
        <Box key={"top-box"} sx={{ display: "flex", justifyContent: "center" }}>
            <Button variant="contained" color="warning"
                disabled={sending}
                component="span" sx={{m: 1}} aria-label={"Voltar"} 
                onClick={() => {{
                    dispatch(filesUploadSlice.actions.clean());
                    props.back();
                }}} >
                Voltar
            </Button>
            <label htmlFor="raised-button-file">
                <Button 
                    disabled={sending}
                    variant="contained" component="span" sx={{m: 1}} aria-label={"Upload"}>
                    Selecionar Arquivos
                </Button>
            </label>
            { sending
            ?   <Button variant="contained" color="error"
                    disabled={!sending}
                    component="span" sx={{m: 1}} aria-label={"Cancelar"} onClick={() => {setSending(false);}} >
                    Cancelar
                </Button>
            :   <Button variant="contained" color="success"
                    disabled={sending}
                    component="span" sx={{m: 1}} aria-label={"Enviar"} onClick={() => {setSending(true);}} >
                    Enviar
                </Button>
            }
        </Box>
    </>;


    return <Box>
        {/* <AppBar position="static" color="default" sx={{mb: 2}}>
            <Toolbar>
                <Typography variant="h6" component="div">
                Adiconar Filens
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Button onClick={handleCancel}>Voltar</Button>
            </Toolbar>
        </AppBar> */}
        {buttons}
        <Paper key={"drop-box"} id="paper" elevation={3} sx={{ p: 2, mx: {xs: 2, sm: 10} }}
            onDragOver={handleDrag} onDragLeave={handleDrag} onDrop={handleDrop}
            style={{ borderColor: dragOver ? PRIZA_THEME.palette.secondary.main : PRIZA_THEME.palette.primary.main, 
                    borderStyle: dragOver ? "dashed" : "dashed",
            padding: 20, textAlign: "center", cursor: "pointer", position: "relative",
            background: PRIZA_THEME.palette.background.paper,  }} >
            <input accept="application/pdf" style={{ display: "none" }} id="raised-button-file" multiple type="file" onChange={handleChange} />
            {
                files.length >   0 
                ?   <Grid container justifyContent="center" style={{ marginBottom: 16 }}>
                        {files.map((fileObj) => (
                            <Box key={fileObj.file.filename} sx={{ minHeight: 200, maxHeight: 200, m: 1, p: 1, border: "1px solid grey", borderRadius: 2 }}>
                                <Typography variant="h6">{fileObj.file.filename}</Typography>
                                <Typography variant="subtitle1" sx={{ background: fileObj.backgroundColor, color: "white", p: 1 }}>{fileObj.status}</Typography>
                                <Typography variant="body2" sx={{ mt: 1 }}>{fileObj.message}</Typography>
                                {fileObj.action && <Box sx={{ mt: 1 }}>{fileObj.action}</Box>}
                            </Box>
                        ))}

                        {/* <FileList variant="quilted" sx={{ p: 0, m: 0, mb: 2 }} cols={columnCount} gap={8}>
                            {files}
                        </FileList> */}
                    </Grid>
                :   <Box sx={{mt: 6, mb: 6}}>
                        <Typography>Arraste uma ou mais filens para esta caixa, ou click para selecionar</Typography>
                    </Box>
            }
        </Paper>
        {buttons}
    </Box>;
}
